import { firstParameterState, memorizeForNg } from '@Utils/Decorators/NgServices';
import * as UserDatabasesSelectors from './UserDatabasesSelectors';

const getAllNg = memorizeForNg(UserDatabasesSelectors.getAll);
const getListWithIdsNg = memorizeForNg(UserDatabasesSelectors.getListWithIds);
const getDatabaseByIdNg = firstParameterState(UserDatabasesSelectors.getDatabaseById);
const getDefaultDatabaseNg = memorizeForNg(UserDatabasesSelectors.getDefaultDatabase);
const getSeparatedDatabasesNg = memorizeForNg(UserDatabasesSelectors.getSeparatedDatabases);
const isDefaultDatabaseNg = firstParameterState(UserDatabasesSelectors.isDefaultDatabase);
const getUserSearchContextsNg = memorizeForNg(UserDatabasesSelectors.getUserSearchContexts);
const getDbNameNg = firstParameterState(UserDatabasesSelectors.getDbName);
const isCIDatabaseNg = firstParameterState(UserDatabasesSelectors.isCIDatabase);
const isRCSDatabaseNg = firstParameterState(UserDatabasesSelectors.isRCSDatabase);
const isPUDatabaseNg = firstParameterState(UserDatabasesSelectors.isPUDatabase);
const supportsReactionNg = firstParameterState(UserDatabasesSelectors.supportsReaction);
const supportsSupplierDataNg = firstParameterState(UserDatabasesSelectors.supportsSupplierData);
const getDatabaseIdByPrefixNg = firstParameterState(UserDatabasesSelectors.getDatabaseIdByPrefix);

export const getAll = () => getAllNg();
export const getListWithIds = () => getListWithIdsNg();
export const getDatabaseById = (id) => {
  const db = getDatabaseByIdNg({ id });
  return db && db.toJS();
};
export const getDefaultDatabase = () => getDefaultDatabaseNg();
export const getSeparatedDatabases = () => getSeparatedDatabasesNg();
export const isDefaultDatabase = (id) => isDefaultDatabaseNg({ id });
export const getUserSearchContexts = () => getUserSearchContextsNg();
export const getDbName = (id) => getDbNameNg({ id });
export const isCIDatabase = (id) => isCIDatabaseNg({ id });
export const isRCSDatabase = (id) => isRCSDatabaseNg({ id });
export const isPUDatabase = (id) => isPUDatabaseNg({ id });
export const supportsReaction = (id) => supportsReactionNg({ id });
export const supportsSupplierData = (id) => supportsSupplierDataNg({ id });
export const getDatabaseIdByPrefix = (prefix) => getDatabaseIdByPrefixNg({ prefix });
